import axios from "axios";
import { Axios } from "index";

export const addItemName = async (details) => {
  try {
    const config = {
      withCredentials: true,
      headers: {
        withCredentials: true,
      },
    };
    const data = await axios.post(
      `${process.env.REACT_APP_URL}/item-name-master/add-item-name-master`,
      details,
      config
    );
    // console.log(data);
    return data;
  } catch (error) {
    // console.log(error);
    return error.response;
  }
};

export const itemNameDropDown = async (type, subCategory) => {
  try {
    const config = {
      withCredentials: true,
      headers: {
        withCredentials: true,
      },
    };

    let url = `${process.env.REACT_APP_URL}/item-name-master/dropdown-item-name-master`;

    const params = new URLSearchParams();
    if (type) params.append("type", type);
    if (subCategory) params.append("subcategory", subCategory);

    const data = await axios.get(`${url}?${params.toString()}`, config);
    return data;
  } catch (error) {
    return error.response;
  }
};

